import React, { useEffect, useState, createContext } from 'react';
import useStoreList from '~/hooks/useStoreList';
import platformAtom from '~/recoil/atom/platform';
import { useRecoilValue } from 'recoil';
import { AlgoliaStore } from '~/types/store/store';
import { FetchingDataStatus } from '~/types/utilities';

export const DisplayStoresContext = createContext<{
  fetchingStatus: FetchingDataStatus;
  stores: Array<AlgoliaStore>;
}>({
  fetchingStatus: FetchingDataStatus.INIT,
  stores: [],
});

export default function DisplayStoresProvider({
  children,
}: {
  children?: React.ReactElement | null;
}) {
  const platform = useRecoilValue(platformAtom);
  const { storeList, fetchingStatus } = useStoreList(platform.displayStores);

  return (
    <DisplayStoresContext.Provider value={{ fetchingStatus: fetchingStatus, stores: storeList }}>
      {children}
    </DisplayStoresContext.Provider>
  );
}
